import React from "react";
export type RecipeErrors = Record<string, string[]>;
export function recipeFieldProps(field: string, errors: RecipeErrors) {
  return {
    "aria-invalid": Boolean(errors[field]),
    "aria-describedby": errors[field] ? `recipe-error-${field}` : undefined,
  };
}
export default function RecipeFieldError({
  field,
  errors,
}: {
  field: string;
  errors: RecipeErrors;
}) {
  if (!errors[field]?.length) return null;
  return (
    <p
      id={`recipe-error-${field}`}
      role="alert"
      className="mt-1 text-sm text-red-700"
    >
      {errors[field].join(" ")}
    </p>
  );
}
